import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/chatRoom-1.png'
import _imports_1 from '../../assets/img/yimo-img/accompany-1.png'
import _imports_2 from '../../assets/img/yimo-img/des-3.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-0e8a1dfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-bg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "chatRoom",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "accompanyWord",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "linkyimo1",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "scrollbottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_footer_c = _resolveComponent("footer-c")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["box2 animate__faster", { animate__animated: _ctx.nowPage === 2, animate__fadeInLeft: _ctx.nowPage === 2 }])
      }, _hoisted_3, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["box3 animate__faster", {
        animate__animated: _ctx.nowPage === 2,
        animate__fadeInRight: _ctx.nowPage === 2
      }])
      }, [
        _hoisted_4,
        _createElementVNode("div", {
          class: _normalizeClass(["pageFourWord", {
          animate__animated: _ctx.nowPage === 2,
          animate__fadeInRight: _ctx.nowPage === 2
        }])
        }, [
          _createTextVNode(" 桌球、你画我猜、谁是卧底、飞行棋、五子棋、扫雷....."),
          _hoisted_5,
          _createTextVNode(" 和你的朋友一起打台球、经典桌游组局玩乐嗨不停！ ")
        ], 2),
        _hoisted_6
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_footer_c)
    ])
  ], 64))
}